import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Sparkles, Loader2 } from "lucide-react";

const SUGGESTIONS = [
  "Weekly sales report for Highpark",
  "Why are we losing deals in Sampoorna Homes?",
  "Show me today's sales control report",
  "Project Health for Highpark last 30 days",
];

export const AskReportBox = ({ onAsk, loading }) => {
  const [question, setQuestion] = useState("");
  const submit = (q) => {
    const v = (q ?? question).trim();
    if (!v) return;
    onAsk(v);
  };
  return (
    <div data-testid="ask-report-box" className="relative rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-900 via-slate-900 to-violet-900 p-6 shadow-lg overflow-hidden">
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-violet-500/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-12 w-64 h-64 rounded-full bg-emerald-500/10 blur-3xl pointer-events-none" />
      <div className="relative">
        <div className="flex items-center gap-2 mb-2">
          <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-white/10 backdrop-blur">
            <Sparkles className="w-4 h-4 text-amber-300" />
          </span>
          <span className="text-[11px] uppercase tracking-wider font-semibold text-white/70">Ask the studio</span>
        </div>
        <h2 className="text-xl font-semibold text-white leading-snug tracking-tight">
          What report would you like to see?
        </h2>
        <p className="text-sm text-white/60 mt-1 max-w-2xl">
          Numbers always come from your CRM. AI only explains them and recommends actions.
        </p>
        <form
          onSubmit={(e) => { e.preventDefault(); submit(); }}
          className="mt-5 flex flex-col sm:flex-row gap-2"
        >
          <Input
            data-testid="ask-report-input"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Ask for a report… e.g., Weekly sales report for Highpark"
            className="flex-1 h-11 bg-white/95 border-0 placeholder:text-slate-400 text-slate-900"
            disabled={loading}
          />
          <Button
            data-testid="ask-report-submit"
            type="submit"
            disabled={loading || !question.trim()}
            className="h-11 px-5 bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1.5" />}
            {loading ? "Thinking…" : "Ask AI"}
          </Button>
        </form>
        <div className="mt-3 flex items-center gap-2 flex-wrap">
          <span className="text-[10px] uppercase tracking-wider text-white/50">Try:</span>
          {SUGGESTIONS.map((s) => (
            <button
              key={s}
              type="button"
              data-testid={`ask-suggestion-${s.slice(0, 12).replace(/\s/g, '-')}`}
              onClick={() => { setQuestion(s); submit(s); }}
              disabled={loading}
              className="text-xs px-3 py-1 rounded-full bg-white/10 hover:bg-white/20 text-white/80 transition-colors disabled:opacity-50"
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AskReportBox;
